import React, { useRef } from 'react'
import {Hero, Attraction} from '../components'
import {attractions} from '../utils/attractions'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

const scrollToRef = (ref) => window.scrollTo(0, 0)   


function AttractionsScreen() {
    useTitle("Attrazioni");
    useDescription("Lista delle bellissime Attrazioni Naturalistiche che puoi trovare a Ceppo.");
    const myRef = useRef(null)
    const executeScroll = () => scrollToRef(myRef)
    return (
        <div ref={myRef}>
            <Hero overlay>
                <hr/>
                    <div>
                        <h3>Attrazioni di Ceppo</h3>
                    </div>
                <hr/>
            </Hero>
            <div className="section-text">
                <div className="attractions-section">                
                {
                    attractions.map(attr=>{
                        return <Attraction key={attr.id} {...attr} scroll={executeScroll}/>
                    })
                }
                </div>
            </div>
        </div>
    )
}

export default AttractionsScreen
